/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramAuthEmailControllerVerifyCodeMutationRequest,
  TelegramAuthEmailControllerVerifyCodeMutationResponse,
  TelegramAuthEmailControllerVerifyCode400,
  TelegramAuthEmailControllerVerifyCode401,
  TelegramAuthEmailControllerVerifyCode403,
  TelegramAuthEmailControllerVerifyCode429,
} from '../../types/TelegramAuthEmailControllerVerifyCode.ts';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { telegramAuthEmailVerifyCode } from '../../methods/telegramAuthEmailVerifyCode.ts';
import { useMutation } from '@tanstack/react-query';

export const telegramAuthEmailVerifyCodeMutationKey = () => [{ url: '/api/telegram/auth/email/verify-code' }] as const;

export type TelegramAuthEmailVerifyCodeMutationKey = ReturnType<typeof telegramAuthEmailVerifyCodeMutationKey>;

/**
 * {@link /api/telegram/auth/email/verify-code}
 */
export function useTelegramAuthEmailVerifyCode<TContext>(
  options: {
    mutation?: UseMutationOptions<
      TelegramAuthEmailControllerVerifyCodeMutationResponse,
      ResponseErrorConfig<
        | TelegramAuthEmailControllerVerifyCode400
        | TelegramAuthEmailControllerVerifyCode401
        | TelegramAuthEmailControllerVerifyCode403
        | TelegramAuthEmailControllerVerifyCode429
      >,
      { data: TelegramAuthEmailControllerVerifyCodeMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<TelegramAuthEmailControllerVerifyCodeMutationRequest>> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? telegramAuthEmailVerifyCodeMutationKey();

  return useMutation<
    TelegramAuthEmailControllerVerifyCodeMutationResponse,
    ResponseErrorConfig<
      | TelegramAuthEmailControllerVerifyCode400
      | TelegramAuthEmailControllerVerifyCode401
      | TelegramAuthEmailControllerVerifyCode403
      | TelegramAuthEmailControllerVerifyCode429
    >,
    { data: TelegramAuthEmailControllerVerifyCodeMutationRequest },
    TContext
  >(
    {
      mutationFn: async ({ data }) => {
        return telegramAuthEmailVerifyCode(data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
